import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import VueGtag from "vue-gtag";

createApp(App).use(VueGtag,{
    config: {id: "UA-131290484-1"}
});

createApp(App).use(store).mount('#app')

